import React, { createContext, FC, useContext } from "react";
import { AppSettingsProps, SessionSettings } from "./AppSettings.types";

/**
 * Create context for easy acces to global settings of an app
 */
export const ContextSettings = createContext<SessionSettings>({} as SessionSettings);

/**
 * Return list of application settings.
 */
export const useSettings: () => SessionSettings = () => useContext(ContextSettings);

/**
 * Provide context for application settings
 */
export const AppSettingsProvider: FC<Omit<AppSettingsProps, "safeLanguageCode">> = ({ settings, children }) => {
  let safeLanguageCode = "en";
  try {
    safeLanguageCode = Intl.getCanonicalLocales(settings.language)[0];
  } catch (e: unknown) {
    safeLanguageCode = settings.language.substring(0, 2);
    console.warn(`Language code ${settings.language} is not valid, fallback to ${safeLanguageCode}: `, e);
  }
  return <ContextSettings.Provider value={{ ...settings, safeLanguageCode }}>{children}</ContextSettings.Provider>;
};
